// AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
// Generated by scripts/autogen-jam-sdk.js
// This file provides a simplified wrapper around the Jam SDK that only exposes promise-based methods

import * as JamSdk from '@amzn/aws-jam-typescript-client';

/**
 * Simplified wrapper around the Jam SDK client that:
 * - Only exposes promise-based methods (no callback overloads)
 * - Returns Promise<Result | Error> for consistent error handling
 * - Maintains the same method signatures as the original SDK
 */
export class SimplifiedJamClient {
  private client: JamSdk.Jam;

  constructor(client: JamSdk.Jam) {
    this.client = client;
  }

  async acceptTerms(input?: JamSdk.AcceptTermsCommandInput) {
    try {
      return await this.client.acceptTerms(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async addCampaignParticipants(input: JamSdk.AddCampaignParticipantsCommandInput) {
    try {
      return await this.client.addCampaignParticipants(input);
    } catch (error) {
      return error as Error;
    }
  }

  async addTeamMember(input: JamSdk.AddTeamMemberCommandInput) {
    try {
      return await this.client.addTeamMember(input);
    } catch (error) {
      return error as Error;
    }
  }

  async addUserGroups(input?: JamSdk.AddUserGroupsCommandInput) {
    try {
      return await this.client.addUserGroups(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async aliasEventTeam(input: JamSdk.AliasEventTeamCommandInput) {
    try {
      return await this.client.aliasEventTeam(input);
    } catch (error) {
      return error as Error;
    }
  }

  async approveCampaignChangeRequest(input: JamSdk.ApproveCampaignChangeRequestCommandInput) {
    try {
      return await this.client.approveCampaignChangeRequest(input);
    } catch (error) {
      return error as Error;
    }
  }

  async approveCampaignRequest(input: JamSdk.ApproveCampaignRequestCommandInput) {
    try {
      return await this.client.approveCampaignRequest(input);
    } catch (error) {
      return error as Error;
    }
  }

  async approveChallengeReview(input?: JamSdk.ApproveChallengeReviewCommandInput) {
    try {
      return await this.client.approveChallengeReview(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async approveEventChangeRequest(input: JamSdk.ApproveEventChangeRequestCommandInput) {
    try {
      return await this.client.approveEventChangeRequest(input);
    } catch (error) {
      return error as Error;
    }
  }

  async approveEventRequest(input: JamSdk.ApproveEventRequestCommandInput) {
    try {
      return await this.client.approveEventRequest(input);
    } catch (error) {
      return error as Error;
    }
  }

  async archiveChallenge(input: JamSdk.ArchiveChallengeCommandInput) {
    try {
      return await this.client.archiveChallenge(input);
    } catch (error) {
      return error as Error;
    }
  }

  async assignEventUserTeam(input: JamSdk.AssignEventUserTeamCommandInput) {
    try {
      return await this.client.assignEventUserTeam(input);
    } catch (error) {
      return error as Error;
    }
  }

  async assignSupportChat(input: JamSdk.AssignSupportChatCommandInput) {
    try {
      return await this.client.assignSupportChat(input);
    } catch (error) {
      return error as Error;
    }
  }

  async cancelCampaignChangeRequest(input: JamSdk.CancelCampaignChangeRequestCommandInput) {
    try {
      return await this.client.cancelCampaignChangeRequest(input);
    } catch (error) {
      return error as Error;
    }
  }

  async cancelCampaignRequest(input: JamSdk.CancelCampaignRequestCommandInput) {
    try {
      return await this.client.cancelCampaignRequest(input);
    } catch (error) {
      return error as Error;
    }
  }

  async cancelChallengeReview(input?: JamSdk.CancelChallengeReviewCommandInput) {
    try {
      return await this.client.cancelChallengeReview(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async cancelEvent(input: JamSdk.CancelEventCommandInput) {
    try {
      return await this.client.cancelEvent(input);
    } catch (error) {
      return error as Error;
    }
  }

  async cancelEventChangeRequest(input: JamSdk.CancelEventChangeRequestCommandInput) {
    try {
      return await this.client.cancelEventChangeRequest(input);
    } catch (error) {
      return error as Error;
    }
  }

  async cancelEventRequest(input: JamSdk.CancelEventRequestCommandInput) {
    try {
      return await this.client.cancelEventRequest(input);
    } catch (error) {
      return error as Error;
    }
  }

  async changeChallengeOwner(input?: JamSdk.ChangeChallengeOwnerCommandInput) {
    try {
      return await this.client.changeChallengeOwner(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async changeEventUserRole(input: JamSdk.ChangeEventUserRoleCommandInput) {
    try {
      return await this.client.changeEventUserRole(input);
    } catch (error) {
      return error as Error;
    }
  }

  async createCampaign(input?: JamSdk.CreateCampaignCommandInput) {
    try {
      return await this.client.createCampaign(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async createCampaignChangeRequest(input: JamSdk.CreateCampaignChangeRequestCommandInput) {
    try {
      return await this.client.createCampaignChangeRequest(input);
    } catch (error) {
      return error as Error;
    }
  }

  async createCampaignComment(input: JamSdk.CreateCampaignCommentCommandInput) {
    try {
      return await this.client.createCampaignComment(input);
    } catch (error) {
      return error as Error;
    }
  }

  async createCampaignGroup(input: JamSdk.CreateCampaignGroupCommandInput) {
    try {
      return await this.client.createCampaignGroup(input);
    } catch (error) {
      return error as Error;
    }
  }

  async createCampaignRequest(input?: JamSdk.CreateCampaignRequestCommandInput) {
    try {
      return await this.client.createCampaignRequest(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async createChallengeBoard(input?: JamSdk.CreateChallengeBoardCommandInput) {
    try {
      return await this.client.createChallengeBoard(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async createChallengeComment(input: JamSdk.CreateChallengeCommentCommandInput) {
    try {
      return await this.client.createChallengeComment(input);
    } catch (error) {
      return error as Error;
    }
  }

  async createChallengeIssue(input?: JamSdk.CreateChallengeIssueCommandInput) {
    try {
      return await this.client.createChallengeIssue(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async createChallengeIssueComment(input: JamSdk.CreateChallengeIssueCommentCommandInput) {
    try {
      return await this.client.createChallengeIssueComment(input);
    } catch (error) {
      return error as Error;
    }
  }

  async createChallengeSet(input?: JamSdk.CreateChallengeSetCommandInput) {
    try {
      return await this.client.createChallengeSet(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async createChallengeTask(input: JamSdk.CreateChallengeTaskCommandInput) {
    try {
      return await this.client.createChallengeTask(input);
    } catch (error) {
      return error as Error;
    }
  }

  async createChallengeTutorial(input?: JamSdk.CreateChallengeTutorialCommandInput) {
    try {
      return await this.client.createChallengeTutorial(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async createConsoleUser(input?: JamSdk.CreateConsoleUserCommandInput) {
    try {
      return await this.client.createConsoleUser(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async createEvent(input?: JamSdk.CreateEventCommandInput) {
    try {
      return await this.client.createEvent(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async createEventChangeRequest(input: JamSdk.CreateEventChangeRequestCommandInput) {
    try {
      return await this.client.createEventChangeRequest(input);
    } catch (error) {
      return error as Error;
    }
  }

  async createEventComment(input: JamSdk.CreateEventCommentCommandInput) {
    try {
      return await this.client.createEventComment(input);
    } catch (error) {
      return error as Error;
    }
  }

  async createEventRequest(input?: JamSdk.CreateEventRequestCommandInput) {
    try {
      return await this.client.createEventRequest(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async createEventTeam(input: JamSdk.CreateEventTeamCommandInput) {
    try {
      return await this.client.createEventTeam(input);
    } catch (error) {
      return error as Error;
    }
  }

  async createLse(input?: JamSdk.CreateLseCommandInput) {
    try {
      return await this.client.createLse(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async createParticipants(input: JamSdk.CreateParticipantsCommandInput) {
    try {
      return await this.client.createParticipants(input);
    } catch (error) {
      return error as Error;
    }
  }

  async createPolarisReview(input: JamSdk.CreatePolarisReviewCommandInput) {
    try {
      return await this.client.createPolarisReview(input);
    } catch (error) {
      return error as Error;
    }
  }

  async createTeam(input: JamSdk.CreateTeamCommandInput) {
    try {
      return await this.client.createTeam(input);
    } catch (error) {
      return error as Error;
    }
  }

  async createTestEvent(input: JamSdk.CreateTestEventCommandInput) {
    try {
      return await this.client.createTestEvent(input);
    } catch (error) {
      return error as Error;
    }
  }

  async createUsagePlan(input?: JamSdk.CreateUsagePlanCommandInput) {
    try {
      return await this.client.createUsagePlan(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async createUsagePlanComment(input: JamSdk.CreateUsagePlanCommentCommandInput) {
    try {
      return await this.client.createUsagePlanComment(input);
    } catch (error) {
      return error as Error;
    }
  }

  async createUserV2(input?: JamSdk.CreateUserV2CommandInput) {
    try {
      return await this.client.createUserV2(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async deleteCampaign(input: JamSdk.DeleteCampaignCommandInput) {
    try {
      return await this.client.deleteCampaign(input);
    } catch (error) {
      return error as Error;
    }
  }

  async deleteCampaignComment(input: JamSdk.DeleteCampaignCommentCommandInput) {
    try {
      return await this.client.deleteCampaignComment(input);
    } catch (error) {
      return error as Error;
    }
  }

  async deleteCampaignGroup(input: JamSdk.DeleteCampaignGroupCommandInput) {
    try {
      return await this.client.deleteCampaignGroup(input);
    } catch (error) {
      return error as Error;
    }
  }

  async deleteChallenge(input: JamSdk.DeleteChallengeCommandInput) {
    try {
      return await this.client.deleteChallenge(input);
    } catch (error) {
      return error as Error;
    }
  }

  async deleteChallengeComment(input: JamSdk.DeleteChallengeCommentCommandInput) {
    try {
      return await this.client.deleteChallengeComment(input);
    } catch (error) {
      return error as Error;
    }
  }

  async deleteChallengeResources(input: JamSdk.DeleteChallengeResourcesCommandInput) {
    try {
      return await this.client.deleteChallengeResources(input);
    } catch (error) {
      return error as Error;
    }
  }

  async deleteChallengeSet(input: JamSdk.DeleteChallengeSetCommandInput) {
    try {
      return await this.client.deleteChallengeSet(input);
    } catch (error) {
      return error as Error;
    }
  }

  async deleteEvent(input: JamSdk.DeleteEventCommandInput) {
    try {
      return await this.client.deleteEvent(input);
    } catch (error) {
      return error as Error;
    }
  }

  async deleteEventComment(input: JamSdk.DeleteEventCommentCommandInput) {
    try {
      return await this.client.deleteEventComment(input);
    } catch (error) {
      return error as Error;
    }
  }

  async deleteEventTeam(input: JamSdk.DeleteEventTeamCommandInput) {
    try {
      return await this.client.deleteEventTeam(input);
    } catch (error) {
      return error as Error;
    }
  }

  async deleteLse(input?: JamSdk.DeleteLseCommandInput) {
    try {
      return await this.client.deleteLse(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async deleteParticipantAccount(input?: JamSdk.DeleteParticipantAccountCommandInput) {
    try {
      return await this.client.deleteParticipantAccount(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async deleteRtf(input?: JamSdk.DeleteRtfCommandInput) {
    try {
      return await this.client.deleteRtf(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async deleteUsagePlanComment(input: JamSdk.DeleteUsagePlanCommentCommandInput) {
    try {
      return await this.client.deleteUsagePlanComment(input);
    } catch (error) {
      return error as Error;
    }
  }

  async denyCampaignChangeRequest(input: JamSdk.DenyCampaignChangeRequestCommandInput) {
    try {
      return await this.client.denyCampaignChangeRequest(input);
    } catch (error) {
      return error as Error;
    }
  }

  async denyCampaignRequest(input: JamSdk.DenyCampaignRequestCommandInput) {
    try {
      return await this.client.denyCampaignRequest(input);
    } catch (error) {
      return error as Error;
    }
  }

  async denyEventChangeRequest(input: JamSdk.DenyEventChangeRequestCommandInput) {
    try {
      return await this.client.denyEventChangeRequest(input);
    } catch (error) {
      return error as Error;
    }
  }

  async denyEventRequest(input: JamSdk.DenyEventRequestCommandInput) {
    try {
      return await this.client.denyEventRequest(input);
    } catch (error) {
      return error as Error;
    }
  }

  async deployChallengeTest(input: JamSdk.DeployChallengeTestCommandInput) {
    try {
      return await this.client.deployChallengeTest(input);
    } catch (error) {
      return error as Error;
    }
  }

  async disableEventTeam(input: JamSdk.DisableEventTeamCommandInput) {
    try {
      return await this.client.disableEventTeam(input);
    } catch (error) {
      return error as Error;
    }
  }

  async disableEventUserAccount(input: JamSdk.DisableEventUserAccountCommandInput) {
    try {
      return await this.client.disableEventUserAccount(input);
    } catch (error) {
      return error as Error;
    }
  }

  async enableEventUserAccount(input: JamSdk.EnableEventUserAccountCommandInput) {
    try {
      return await this.client.enableEventUserAccount(input);
    } catch (error) {
      return error as Error;
    }
  }

  async enableMessaging(input: JamSdk.EnableMessagingCommandInput) {
    try {
      return await this.client.enableMessaging(input);
    } catch (error) {
      return error as Error;
    }
  }

  async endSupportChat(input: JamSdk.EndSupportChatCommandInput) {
    try {
      return await this.client.endSupportChat(input);
    } catch (error) {
      return error as Error;
    }
  }

  async exportChallengeSponsorLeads(input: JamSdk.ExportChallengeSponsorLeadsCommandInput) {
    try {
      return await this.client.exportChallengeSponsorLeads(input);
    } catch (error) {
      return error as Error;
    }
  }

  async exportEventAllParticipants(input: JamSdk.ExportEventAllParticipantsCommandInput) {
    try {
      return await this.client.exportEventAllParticipants(input);
    } catch (error) {
      return error as Error;
    }
  }

  async exportEventSolvedParticipants(input: JamSdk.ExportEventSolvedParticipantsCommandInput) {
    try {
      return await this.client.exportEventSolvedParticipants(input);
    } catch (error) {
      return error as Error;
    }
  }

  async extendChallengeTest(input: JamSdk.ExtendChallengeTestCommandInput) {
    try {
      return await this.client.extendChallengeTest(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorAddTime(input: JamSdk.FacilitatorAddTimeCommandInput) {
    try {
      return await this.client.facilitatorAddTime(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorAssignTeam(input: JamSdk.FacilitatorAssignTeamCommandInput) {
    try {
      return await this.client.facilitatorAssignTeam(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorAutoAssign(input: JamSdk.FacilitatorAutoAssignCommandInput) {
    try {
      return await this.client.facilitatorAutoAssign(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorCreateIssue(input: JamSdk.FacilitatorCreateIssueCommandInput) {
    try {
      return await this.client.facilitatorCreateIssue(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorDisableSupportChat(input: JamSdk.FacilitatorDisableSupportChatCommandInput) {
    try {
      return await this.client.facilitatorDisableSupportChat(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorEnableSupportChat(input: JamSdk.FacilitatorEnableSupportChatCommandInput) {
    try {
      return await this.client.facilitatorEnableSupportChat(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorGetCount(input: JamSdk.FacilitatorGetCountCommandInput) {
    try {
      return await this.client.facilitatorGetCount(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorGetEventParticipants(input: JamSdk.FacilitatorGetEventParticipantsCommandInput) {
    try {
      return await this.client.facilitatorGetEventParticipants(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorGetIncidents(input: JamSdk.FacilitatorGetIncidentsCommandInput) {
    try {
      return await this.client.facilitatorGetIncidents(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorGetIssues(input: JamSdk.FacilitatorGetIssuesCommandInput) {
    try {
      return await this.client.facilitatorGetIssues(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorGetParticipants(input: JamSdk.FacilitatorGetParticipantsCommandInput) {
    try {
      return await this.client.facilitatorGetParticipants(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorGetRecentFeedback(input: JamSdk.FacilitatorGetRecentFeedbackCommandInput) {
    try {
      return await this.client.facilitatorGetRecentFeedback(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorGetSupportDetails(input: JamSdk.FacilitatorGetSupportDetailsCommandInput) {
    try {
      return await this.client.facilitatorGetSupportDetails(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorGetTeamsAvailability(input: JamSdk.FacilitatorGetTeamsAvailabilityCommandInput) {
    try {
      return await this.client.facilitatorGetTeamsAvailability(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorLabKeypair(input: JamSdk.FacilitatorLabKeypairCommandInput) {
    try {
      return await this.client.facilitatorLabKeypair(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorLockChallenges(input: JamSdk.FacilitatorLockChallengesCommandInput) {
    try {
      return await this.client.facilitatorLockChallenges(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorLockTeamAlias(input: JamSdk.FacilitatorLockTeamAliasCommandInput) {
    try {
      return await this.client.facilitatorLockTeamAlias(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorMarkChallengeSolved(input: JamSdk.FacilitatorMarkChallengeSolvedCommandInput) {
    try {
      return await this.client.facilitatorMarkChallengeSolved(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorRefundClue(input: JamSdk.FacilitatorRefundClueCommandInput) {
    try {
      return await this.client.facilitatorRefundClue(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorRestartChallenge(input: JamSdk.FacilitatorRestartChallengeCommandInput) {
    try {
      return await this.client.facilitatorRestartChallenge(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorSendMessage(input: JamSdk.FacilitatorSendMessageCommandInput) {
    try {
      return await this.client.facilitatorSendMessage(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorSendParticipantMessage(input: JamSdk.FacilitatorSendParticipantMessageCommandInput) {
    try {
      return await this.client.facilitatorSendParticipantMessage(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorSendTeamMessage(input: JamSdk.FacilitatorSendTeamMessageCommandInput) {
    try {
      return await this.client.facilitatorSendTeamMessage(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorSetTeamName(input: JamSdk.FacilitatorSetTeamNameCommandInput) {
    try {
      return await this.client.facilitatorSetTeamName(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorSetTeamOwner(input: JamSdk.FacilitatorSetTeamOwnerCommandInput) {
    try {
      return await this.client.facilitatorSetTeamOwner(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorSetTeamPassword(input: JamSdk.FacilitatorSetTeamPasswordCommandInput) {
    try {
      return await this.client.facilitatorSetTeamPassword(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorStartChat(input: JamSdk.FacilitatorStartChatCommandInput) {
    try {
      return await this.client.facilitatorStartChat(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorSubtractTime(input: JamSdk.FacilitatorSubtractTimeCommandInput) {
    try {
      return await this.client.facilitatorSubtractTime(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorTeamProgress(input: JamSdk.FacilitatorTeamProgressCommandInput) {
    try {
      return await this.client.facilitatorTeamProgress(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorUnassignTeam(input: JamSdk.FacilitatorUnassignTeamCommandInput) {
    try {
      return await this.client.facilitatorUnassignTeam(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorUnlockChallenges(input: JamSdk.FacilitatorUnlockChallengesCommandInput) {
    try {
      return await this.client.facilitatorUnlockChallenges(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorUnlockTeamAlias(input: JamSdk.FacilitatorUnlockTeamAliasCommandInput) {
    try {
      return await this.client.facilitatorUnlockTeamAlias(input);
    } catch (error) {
      return error as Error;
    }
  }

  async facilitatorUpdateChallengeNotes(input: JamSdk.FacilitatorUpdateChallengeNotesCommandInput) {
    try {
      return await this.client.facilitatorUpdateChallengeNotes(input);
    } catch (error) {
      return error as Error;
    }
  }

  async fetchUserEmail(input: JamSdk.FetchUserEmailCommandInput) {
    try {
      return await this.client.fetchUserEmail(input);
    } catch (error) {
      return error as Error;
    }
  }

  async fetchUserEmails(input: JamSdk.FetchUserEmailsCommandInput) {
    try {
      return await this.client.fetchUserEmails(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getAllEventStatistics(input?: JamSdk.GetAllEventStatisticsCommandInput) {
    try {
      return await this.client.getAllEventStatistics(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async getAllSupportChats(input: JamSdk.GetAllSupportChatsCommandInput) {
    try {
      return await this.client.getAllSupportChats(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getCampaign(input: JamSdk.GetCampaignCommandInput) {
    try {
      return await this.client.getCampaign(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getCampaignGroup(input: JamSdk.GetCampaignGroupCommandInput) {
    try {
      return await this.client.getCampaignGroup(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getCampaignParticipant(input: JamSdk.GetCampaignParticipantCommandInput) {
    try {
      return await this.client.getCampaignParticipant(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getChallenge(input: JamSdk.GetChallengeCommandInput) {
    try {
      return await this.client.getChallenge(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getChallengeBoard(input: JamSdk.GetChallengeBoardCommandInput) {
    try {
      return await this.client.getChallengeBoard(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getChallengeDefectiveWarning(input: JamSdk.GetChallengeDefectiveWarningCommandInput) {
    try {
      return await this.client.getChallengeDefectiveWarning(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getChallengeEventsUsed(input: JamSdk.GetChallengeEventsUsedCommandInput) {
    try {
      return await this.client.getChallengeEventsUsed(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getChallengeFeedbackSummary(input: JamSdk.GetChallengeFeedbackSummaryCommandInput) {
    try {
      return await this.client.getChallengeFeedbackSummary(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getChallengeFeedbackTrend(input: JamSdk.GetChallengeFeedbackTrendCommandInput) {
    try {
      return await this.client.getChallengeFeedbackTrend(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getChallengeFeedbackTrendAll(input: JamSdk.GetChallengeFeedbackTrendAllCommandInput) {
    try {
      return await this.client.getChallengeFeedbackTrendAll(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getChallengeHistory(input: JamSdk.GetChallengeHistoryCommandInput) {
    try {
      return await this.client.getChallengeHistory(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getChallengeHistoryVersion(input: JamSdk.GetChallengeHistoryVersionCommandInput) {
    try {
      return await this.client.getChallengeHistoryVersion(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getChallengeIssue(input: JamSdk.GetChallengeIssueCommandInput) {
    try {
      return await this.client.getChallengeIssue(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getChallengeIssueAttachment(input: JamSdk.GetChallengeIssueAttachmentCommandInput) {
    try {
      return await this.client.getChallengeIssueAttachment(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getChallengeLeadEvents(input: JamSdk.GetChallengeLeadEventsCommandInput) {
    try {
      return await this.client.getChallengeLeadEvents(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getChallengeRecommendations(input?: JamSdk.GetChallengeRecommendationsCommandInput) {
    try {
      return await this.client.getChallengeRecommendations(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async getChallengeRecommendationsAsync(input?: JamSdk.GetChallengeRecommendationsAsyncCommandInput) {
    try {
      return await this.client.getChallengeRecommendationsAsync(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async getChallengeResourceCredentials(input: JamSdk.GetChallengeResourceCredentialsCommandInput) {
    try {
      return await this.client.getChallengeResourceCredentials(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getChallengeResources(input: JamSdk.GetChallengeResourcesCommandInput) {
    try {
      return await this.client.getChallengeResources(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getChallengeReviewApproval(input: JamSdk.GetChallengeReviewApprovalCommandInput) {
    try {
      return await this.client.getChallengeReviewApproval(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getChallengesConfig(input?: JamSdk.GetChallengesConfigCommandInput) {
    try {
      return await this.client.getChallengesConfig(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async getChallengesCount(input?: JamSdk.GetChallengesCountCommandInput) {
    try {
      return await this.client.getChallengesCount(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async getChallengeSet(input: JamSdk.GetChallengeSetCommandInput) {
    try {
      return await this.client.getChallengeSet(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getChallengeSetChallenges(input: JamSdk.GetChallengeSetChallengesCommandInput) {
    try {
      return await this.client.getChallengeSetChallenges(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getChallengeStatistics(input: JamSdk.GetChallengeStatisticsCommandInput) {
    try {
      return await this.client.getChallengeStatistics(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getChallengeTags(input?: JamSdk.GetChallengeTagsCommandInput) {
    try {
      return await this.client.getChallengeTags(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async getChallengeTeamsSolved(input: JamSdk.GetChallengeTeamsSolvedCommandInput) {
    try {
      return await this.client.getChallengeTeamsSolved(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getChallengeTranslation(input: JamSdk.GetChallengeTranslationCommandInput) {
    try {
      return await this.client.getChallengeTranslation(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getChallengeTutorial(input?: JamSdk.GetChallengeTutorialCommandInput) {
    try {
      return await this.client.getChallengeTutorial(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async getDsar(input?: JamSdk.GetDsarCommandInput) {
    try {
      return await this.client.getDsar(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async getEvent(input: JamSdk.GetEventCommandInput) {
    try {
      return await this.client.getEvent(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getEventByOrder(input: JamSdk.GetEventByOrderCommandInput) {
    try {
      return await this.client.getEventByOrder(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getEventChallengeDetails(input: JamSdk.GetEventChallengeDetailsCommandInput) {
    try {
      return await this.client.getEventChallengeDetails(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getEventChallengeFeedback(input: JamSdk.GetEventChallengeFeedbackCommandInput) {
    try {
      return await this.client.getEventChallengeFeedback(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getEventChallengeProperties(input: JamSdk.GetEventChallengePropertiesCommandInput) {
    try {
      return await this.client.getEventChallengeProperties(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getEventConfig(input?: JamSdk.GetEventConfigCommandInput) {
    try {
      return await this.client.getEventConfig(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async getEventDashboard(input: JamSdk.GetEventDashboardCommandInput) {
    try {
      return await this.client.getEventDashboard(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getEventDetails(input: JamSdk.GetEventDetailsCommandInput) {
    try {
      return await this.client.getEventDetails(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getEventFeedback(input: JamSdk.GetEventFeedbackCommandInput) {
    try {
      return await this.client.getEventFeedback(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getEventLabAdminSignIn(input: JamSdk.GetEventLabAdminSignInCommandInput) {
    try {
      return await this.client.getEventLabAdminSignIn(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getEventLabAutoscalingDecisions(input: JamSdk.GetEventLabAutoscalingDecisionsCommandInput) {
    try {
      return await this.client.getEventLabAutoscalingDecisions(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getEventLabChallenge(input: JamSdk.GetEventLabChallengeCommandInput) {
    try {
      return await this.client.getEventLabChallenge(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getEventLabChallengeAuditTrail(input: JamSdk.GetEventLabChallengeAuditTrailCommandInput) {
    try {
      return await this.client.getEventLabChallengeAuditTrail(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getEventLabKeypair(input: JamSdk.GetEventLabKeypairCommandInput) {
    try {
      return await this.client.getEventLabKeypair(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getEventLabMasterSignIn(input: JamSdk.GetEventLabMasterSignInCommandInput) {
    try {
      return await this.client.getEventLabMasterSignIn(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getEventLabMetadata(input: JamSdk.GetEventLabMetadataCommandInput) {
    try {
      return await this.client.getEventLabMetadata(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getEventLabResourceHistory(input: JamSdk.GetEventLabResourceHistoryCommandInput) {
    try {
      return await this.client.getEventLabResourceHistory(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getEventLabsAuditTrail(input: JamSdk.GetEventLabsAuditTrailCommandInput) {
    try {
      return await this.client.getEventLabsAuditTrail(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getEventLabsChartData(input: JamSdk.GetEventLabsChartDataCommandInput) {
    try {
      return await this.client.getEventLabsChartData(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getEventLabsSummary(input: JamSdk.GetEventLabsSummaryCommandInput) {
    try {
      return await this.client.getEventLabsSummary(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getEventLabStackInfo(input: JamSdk.GetEventLabStackInfoCommandInput) {
    try {
      return await this.client.getEventLabStackInfo(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getEventLabTeamSignIn(input: JamSdk.GetEventLabTeamSignInCommandInput) {
    try {
      return await this.client.getEventLabTeamSignIn(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getEventLeaderboard(input: JamSdk.GetEventLeaderboardCommandInput) {
    try {
      return await this.client.getEventLeaderboard(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getEventLeaderboardHistory(input: JamSdk.GetEventLeaderboardHistoryCommandInput) {
    try {
      return await this.client.getEventLeaderboardHistory(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getEventParticipant(input: JamSdk.GetEventParticipantCommandInput) {
    try {
      return await this.client.getEventParticipant(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getEventParticipantsCount(input: JamSdk.GetEventParticipantsCountCommandInput) {
    try {
      return await this.client.getEventParticipantsCount(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getEventPath(input: JamSdk.GetEventPathCommandInput) {
    try {
      return await this.client.getEventPath(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getEventReport(input: JamSdk.GetEventReportCommandInput) {
    try {
      return await this.client.getEventReport(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getEventTeam(input: JamSdk.GetEventTeamCommandInput) {
    try {
      return await this.client.getEventTeam(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getEventTeamLeaderboard(input: JamSdk.GetEventTeamLeaderboardCommandInput) {
    try {
      return await this.client.getEventTeamLeaderboard(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getEventTeams(input: JamSdk.GetEventTeamsCommandInput) {
    try {
      return await this.client.getEventTeams(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getGameDayTemplates(input?: JamSdk.GetGameDayTemplatesCommandInput) {
    try {
      return await this.client.getGameDayTemplates(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async getLabsDashboard(input: JamSdk.GetLabsDashboardCommandInput) {
    try {
      return await this.client.getLabsDashboard(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getLabShutoffAuditTrail(input: JamSdk.GetLabShutoffAuditTrailCommandInput) {
    try {
      return await this.client.getLabShutoffAuditTrail(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getLabShutoffStatus(input?: JamSdk.GetLabShutoffStatusCommandInput) {
    try {
      return await this.client.getLabShutoffStatus(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async getLatestPolarisReviews(input: JamSdk.GetLatestPolarisReviewsCommandInput) {
    try {
      return await this.client.getLatestPolarisReviews(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getLocalization(input: JamSdk.GetLocalizationCommandInput) {
    try {
      return await this.client.getLocalization(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getLse(input?: JamSdk.GetLseCommandInput) {
    try {
      return await this.client.getLse(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async getParticipantConsent(input: JamSdk.GetParticipantConsentCommandInput) {
    try {
      return await this.client.getParticipantConsent(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getParticipantDashboard(input?: JamSdk.GetParticipantDashboardCommandInput) {
    try {
      return await this.client.getParticipantDashboard(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async getParticipantEventReport(input: JamSdk.GetParticipantEventReportCommandInput) {
    try {
      return await this.client.getParticipantEventReport(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getParticipantFeedback(input: JamSdk.GetParticipantFeedbackCommandInput) {
    try {
      return await this.client.getParticipantFeedback(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getParticipantInviteTemplate(input: JamSdk.GetParticipantInviteTemplateCommandInput) {
    try {
      return await this.client.getParticipantInviteTemplate(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getParticipantMessages(input: JamSdk.GetParticipantMessagesCommandInput) {
    try {
      return await this.client.getParticipantMessages(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getParticipantOngoingEvents(input?: JamSdk.GetParticipantOngoingEventsCommandInput) {
    try {
      return await this.client.getParticipantOngoingEvents(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async getParticipantPastEvents(input?: JamSdk.GetParticipantPastEventsCommandInput) {
    try {
      return await this.client.getParticipantPastEvents(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async getParticipantProfile(input?: JamSdk.GetParticipantProfileCommandInput) {
    try {
      return await this.client.getParticipantProfile(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async getParticipantSkill(input?: JamSdk.GetParticipantSkillCommandInput) {
    try {
      return await this.client.getParticipantSkill(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async getParticipantUpcomingEvents(input?: JamSdk.GetParticipantUpcomingEventsCommandInput) {
    try {
      return await this.client.getParticipantUpcomingEvents(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async getPolarisReview(input: JamSdk.GetPolarisReviewCommandInput) {
    try {
      return await this.client.getPolarisReview(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getPrize(input: JamSdk.GetPrizeCommandInput) {
    try {
      return await this.client.getPrize(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getPublicEvents(input?: JamSdk.GetPublicEventsCommandInput) {
    try {
      return await this.client.getPublicEvents(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async getSnippet(input: JamSdk.GetSnippetCommandInput) {
    try {
      return await this.client.getSnippet(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getSnippetsByType(input: JamSdk.GetSnippetsByTypeCommandInput) {
    try {
      return await this.client.getSnippetsByType(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getSupportChatDetails(input: JamSdk.GetSupportChatDetailsCommandInput) {
    try {
      return await this.client.getSupportChatDetails(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getSupportChats(input: JamSdk.GetSupportChatsCommandInput) {
    try {
      return await this.client.getSupportChats(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getTeamChallengeKeypair(input: JamSdk.GetTeamChallengeKeypairCommandInput) {
    try {
      return await this.client.getTeamChallengeKeypair(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getTeamChallengeProgress(input: JamSdk.GetTeamChallengeProgressCommandInput) {
    try {
      return await this.client.getTeamChallengeProgress(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getTeamChallengeProperties(input: JamSdk.GetTeamChallengePropertiesCommandInput) {
    try {
      return await this.client.getTeamChallengeProperties(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getTeamChallengeQueueInfo(input: JamSdk.GetTeamChallengeQueueInfoCommandInput) {
    try {
      return await this.client.getTeamChallengeQueueInfo(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getTeamChat(input: JamSdk.GetTeamChatCommandInput) {
    try {
      return await this.client.getTeamChat(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getTeammateHistory(input: JamSdk.GetTeammateHistoryCommandInput) {
    try {
      return await this.client.getTeammateHistory(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getTermsStatus(input?: JamSdk.GetTermsStatusCommandInput) {
    try {
      return await this.client.getTermsStatus(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async getUnassignedSupportChats(input: JamSdk.GetUnassignedSupportChatsCommandInput) {
    try {
      return await this.client.getUnassignedSupportChats(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getUsagePlan(input: JamSdk.GetUsagePlanCommandInput) {
    try {
      return await this.client.getUsagePlan(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getUsagePlanComments(input: JamSdk.GetUsagePlanCommentsCommandInput) {
    try {
      return await this.client.getUsagePlanComments(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getUsagePlanDashboard(input: JamSdk.GetUsagePlanDashboardCommandInput) {
    try {
      return await this.client.getUsagePlanDashboard(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getUser(input: JamSdk.GetUserCommandInput) {
    try {
      return await this.client.getUser(input);
    } catch (error) {
      return error as Error;
    }
  }

  async getUserByVibeId(input: JamSdk.GetUserByVibeIdCommandInput) {
    try {
      return await this.client.getUserByVibeId(input);
    } catch (error) {
      return error as Error;
    }
  }

  async inviteCampaignGroup(input: JamSdk.InviteCampaignGroupCommandInput) {
    try {
      return await this.client.inviteCampaignGroup(input);
    } catch (error) {
      return error as Error;
    }
  }

  async inviteCampaignParticipants(input: JamSdk.InviteCampaignParticipantsCommandInput) {
    try {
      return await this.client.inviteCampaignParticipants(input);
    } catch (error) {
      return error as Error;
    }
  }

  async inviteEventParticipants(input: JamSdk.InviteEventParticipantsCommandInput) {
    try {
      return await this.client.inviteEventParticipants(input);
    } catch (error) {
      return error as Error;
    }
  }

  async labShutoff(input?: JamSdk.LabShutoffCommandInput) {
    try {
      return await this.client.labShutoff(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async labTurnon(input?: JamSdk.LabTurnonCommandInput) {
    try {
      return await this.client.labTurnon(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async listCampaignGroups(input: JamSdk.ListCampaignGroupsCommandInput) {
    try {
      return await this.client.listCampaignGroups(input);
    } catch (error) {
      return error as Error;
    }
  }

  async listCampaignParticipants(input: JamSdk.ListCampaignParticipantsCommandInput) {
    try {
      return await this.client.listCampaignParticipants(input);
    } catch (error) {
      return error as Error;
    }
  }

  async listCampaigns(input?: JamSdk.ListCampaignsCommandInput) {
    try {
      return await this.client.listCampaigns(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async listChallengeBoards(input?: JamSdk.ListChallengeBoardsCommandInput) {
    try {
      return await this.client.listChallengeBoards(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async listChallengeIssuesByChallenge(input: JamSdk.ListChallengeIssuesByChallengeCommandInput) {
    try {
      return await this.client.listChallengeIssuesByChallenge(input);
    } catch (error) {
      return error as Error;
    }
  }

  async listChallenges(input?: JamSdk.ListChallengesCommandInput) {
    try {
      return await this.client.listChallenges(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async listChallengeSets(input?: JamSdk.ListChallengeSetsCommandInput) {
    try {
      return await this.client.listChallengeSets(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async listChallengeValidations(input: JamSdk.ListChallengeValidationsCommandInput) {
    try {
      return await this.client.listChallengeValidations(input);
    } catch (error) {
      return error as Error;
    }
  }

  async listEvents(input?: JamSdk.ListEventsCommandInput) {
    try {
      return await this.client.listEvents(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async listEventsMin(input?: JamSdk.ListEventsMinCommandInput) {
    try {
      return await this.client.listEventsMin(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async listUsagePlans(input?: JamSdk.ListUsagePlansCommandInput) {
    try {
      return await this.client.listUsagePlans(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async listUsers(input?: JamSdk.ListUsersCommandInput) {
    try {
      return await this.client.listUsers(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async loadCampaignEvent(input: JamSdk.LoadCampaignEventCommandInput) {
    try {
      return await this.client.loadCampaignEvent(input);
    } catch (error) {
      return error as Error;
    }
  }

  async loadEvent(input: JamSdk.LoadEventCommandInput) {
    try {
      return await this.client.loadEvent(input);
    } catch (error) {
      return error as Error;
    }
  }

  async loadEventById(input: JamSdk.LoadEventByIdCommandInput) {
    try {
      return await this.client.loadEventById(input);
    } catch (error) {
      return error as Error;
    }
  }

  async lockEventChallenges(input: JamSdk.LockEventChallengesCommandInput) {
    try {
      return await this.client.lockEventChallenges(input);
    } catch (error) {
      return error as Error;
    }
  }

  async markChallengeDefective(input?: JamSdk.MarkChallengeDefectiveCommandInput) {
    try {
      return await this.client.markChallengeDefective(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async markChallengeDemo(input?: JamSdk.MarkChallengeDemoCommandInput) {
    try {
      return await this.client.markChallengeDemo(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async markChallengePublic(input?: JamSdk.MarkChallengePublicCommandInput) {
    try {
      return await this.client.markChallengePublic(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async markParticipantMessagesRead(input: JamSdk.MarkParticipantMessagesReadCommandInput) {
    try {
      return await this.client.markParticipantMessagesRead(input);
    } catch (error) {
      return error as Error;
    }
  }

  async pendingCampaignChangeRequest(input: JamSdk.PendingCampaignChangeRequestCommandInput) {
    try {
      return await this.client.pendingCampaignChangeRequest(input);
    } catch (error) {
      return error as Error;
    }
  }

  async pendingCampaignRequest(input: JamSdk.PendingCampaignRequestCommandInput) {
    try {
      return await this.client.pendingCampaignRequest(input);
    } catch (error) {
      return error as Error;
    }
  }

  async previewCampaignInvite(input: JamSdk.PreviewCampaignInviteCommandInput) {
    try {
      return await this.client.previewCampaignInvite(input);
    } catch (error) {
      return error as Error;
    }
  }

  async redeemChallengePrize(input: JamSdk.RedeemChallengePrizeCommandInput) {
    try {
      return await this.client.redeemChallengePrize(input);
    } catch (error) {
      return error as Error;
    }
  }

  async redeemEventPrize(input: JamSdk.RedeemEventPrizeCommandInput) {
    try {
      return await this.client.redeemEventPrize(input);
    } catch (error) {
      return error as Error;
    }
  }

  async redeployChallengeTest(input: JamSdk.RedeployChallengeTestCommandInput) {
    try {
      return await this.client.redeployChallengeTest(input);
    } catch (error) {
      return error as Error;
    }
  }

  async reevaluateUsagePlan(input: JamSdk.ReevaluateUsagePlanCommandInput) {
    try {
      return await this.client.reevaluateUsagePlan(input);
    } catch (error) {
      return error as Error;
    }
  }

  async rejectChallengeReview(input?: JamSdk.RejectChallengeReviewCommandInput) {
    try {
      return await this.client.rejectChallengeReview(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async removeCampaignParticipants(input: JamSdk.RemoveCampaignParticipantsCommandInput) {
    try {
      return await this.client.removeCampaignParticipants(input);
    } catch (error) {
      return error as Error;
    }
  }

  async removeChallengeTask(input: JamSdk.RemoveChallengeTaskCommandInput) {
    try {
      return await this.client.removeChallengeTask(input);
    } catch (error) {
      return error as Error;
    }
  }

  async removeLocalization(input: JamSdk.RemoveLocalizationCommandInput) {
    try {
      return await this.client.removeLocalization(input);
    } catch (error) {
      return error as Error;
    }
  }

  async removeParticipants(input: JamSdk.RemoveParticipantsCommandInput) {
    try {
      return await this.client.removeParticipants(input);
    } catch (error) {
      return error as Error;
    }
  }

  async removeUserGroups(input?: JamSdk.RemoveUserGroupsCommandInput) {
    try {
      return await this.client.removeUserGroups(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async requestChallengeReview(input?: JamSdk.RequestChallengeReviewCommandInput) {
    try {
      return await this.client.requestChallengeReview(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async resetEvent(input: JamSdk.ResetEventCommandInput) {
    try {
      return await this.client.resetEvent(input);
    } catch (error) {
      return error as Error;
    }
  }

  async resetEventTeams(input: JamSdk.ResetEventTeamsCommandInput) {
    try {
      return await this.client.resetEventTeams(input);
    } catch (error) {
      return error as Error;
    }
  }

  async restartTeamChallenge(input: JamSdk.RestartTeamChallengeCommandInput) {
    try {
      return await this.client.restartTeamChallenge(input);
    } catch (error) {
      return error as Error;
    }
  }

  async retranslateChallenge(input: JamSdk.RetranslateChallengeCommandInput) {
    try {
      return await this.client.retranslateChallenge(input);
    } catch (error) {
      return error as Error;
    }
  }

  async retranslateChallengeAttribute(input: JamSdk.RetranslateChallengeAttributeCommandInput) {
    try {
      return await this.client.retranslateChallengeAttribute(input);
    } catch (error) {
      return error as Error;
    }
  }

  async searchEventParticipants(input: JamSdk.SearchEventParticipantsCommandInput) {
    try {
      return await this.client.searchEventParticipants(input);
    } catch (error) {
      return error as Error;
    }
  }

  async searchEventParticipantsByQuery(input: JamSdk.SearchEventParticipantsByQueryCommandInput) {
    try {
      return await this.client.searchEventParticipantsByQuery(input);
    } catch (error) {
      return error as Error;
    }
  }

  async sendSupportChatMessage(input: JamSdk.SendSupportChatMessageCommandInput) {
    try {
      return await this.client.sendSupportChatMessage(input);
    } catch (error) {
      return error as Error;
    }
  }

  async sendTeamChat(input: JamSdk.SendTeamChatCommandInput) {
    try {
      return await this.client.sendTeamChat(input);
    } catch (error) {
      return error as Error;
    }
  }

  async sendTeammateMessage(input: JamSdk.SendTeammateMessageCommandInput) {
    try {
      return await this.client.sendTeammateMessage(input);
    } catch (error) {
      return error as Error;
    }
  }

  async setParticipantLanguage(input: JamSdk.SetParticipantLanguageCommandInput) {
    try {
      return await this.client.setParticipantLanguage(input);
    } catch (error) {
      return error as Error;
    }
  }

  async setTeamAlias(input: JamSdk.SetTeamAliasCommandInput) {
    try {
      return await this.client.setTeamAlias(input);
    } catch (error) {
      return error as Error;
    }
  }

  async setTeamGoal(input: JamSdk.SetTeamGoalCommandInput) {
    try {
      return await this.client.setTeamGoal(input);
    } catch (error) {
      return error as Error;
    }
  }

  async setTeamPassword(input: JamSdk.SetTeamPasswordCommandInput) {
    try {
      return await this.client.setTeamPassword(input);
    } catch (error) {
      return error as Error;
    }
  }

  async startCampaignChallenge(input: JamSdk.StartCampaignChallengeCommandInput) {
    try {
      return await this.client.startCampaignChallenge(input);
    } catch (error) {
      return error as Error;
    }
  }

  async startChallengeReview(input?: JamSdk.StartChallengeReviewCommandInput) {
    try {
      return await this.client.startChallengeReview(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async startChallengeValidation(input: JamSdk.StartChallengeValidationCommandInput) {
    try {
      return await this.client.startChallengeValidation(input);
    } catch (error) {
      return error as Error;
    }
  }

  async startSupportChat(input?: JamSdk.StartSupportChatCommandInput) {
    try {
      return await this.client.startSupportChat(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async startTeamChallenge(input: JamSdk.StartTeamChallengeCommandInput) {
    try {
      return await this.client.startTeamChallenge(input);
    } catch (error) {
      return error as Error;
    }
  }

  async submitChallengeEventFeedback(input: JamSdk.SubmitChallengeEventFeedbackCommandInput) {
    try {
      return await this.client.submitChallengeEventFeedback(input);
    } catch (error) {
      return error as Error;
    }
  }

  async submitChallengeFeedback(input: JamSdk.SubmitChallengeFeedbackCommandInput) {
    try {
      return await this.client.submitChallengeFeedback(input);
    } catch (error) {
      return error as Error;
    }
  }

  async submitEventFeedback(input: JamSdk.SubmitEventFeedbackCommandInput) {
    try {
      return await this.client.submitEventFeedback(input);
    } catch (error) {
      return error as Error;
    }
  }

  async submitParticipantConsent(input: JamSdk.SubmitParticipantConsentCommandInput) {
    try {
      return await this.client.submitParticipantConsent(input);
    } catch (error) {
      return error as Error;
    }
  }

  async submitPolarisReview(input: JamSdk.SubmitPolarisReviewCommandInput) {
    try {
      return await this.client.submitPolarisReview(input);
    } catch (error) {
      return error as Error;
    }
  }

  async supportChatMarkSolved(input: JamSdk.SupportChatMarkSolvedCommandInput) {
    try {
      return await this.client.supportChatMarkSolved(input);
    } catch (error) {
      return error as Error;
    }
  }

  async supportChatRestartChallenge(input: JamSdk.SupportChatRestartChallengeCommandInput) {
    try {
      return await this.client.supportChatRestartChallenge(input);
    } catch (error) {
      return error as Error;
    }
  }

  async terminateChallengeTest(input: JamSdk.TerminateChallengeTestCommandInput) {
    try {
      return await this.client.terminateChallengeTest(input);
    } catch (error) {
      return error as Error;
    }
  }

  async terminateEventChallengeLabs(input: JamSdk.TerminateEventChallengeLabsCommandInput) {
    try {
      return await this.client.terminateEventChallengeLabs(input);
    } catch (error) {
      return error as Error;
    }
  }

  async terminateEventLab(input: JamSdk.TerminateEventLabCommandInput) {
    try {
      return await this.client.terminateEventLab(input);
    } catch (error) {
      return error as Error;
    }
  }

  async terminateEventLabs(input: JamSdk.TerminateEventLabsCommandInput) {
    try {
      return await this.client.terminateEventLabs(input);
    } catch (error) {
      return error as Error;
    }
  }

  async trackSolveButton(input: JamSdk.TrackSolveButtonCommandInput) {
    try {
      return await this.client.trackSolveButton(input);
    } catch (error) {
      return error as Error;
    }
  }

  async unarchiveChallenge(input: JamSdk.UnarchiveChallengeCommandInput) {
    try {
      return await this.client.unarchiveChallenge(input);
    } catch (error) {
      return error as Error;
    }
  }

  async unassignLabAccount(input: JamSdk.UnassignLabAccountCommandInput) {
    try {
      return await this.client.unassignLabAccount(input);
    } catch (error) {
      return error as Error;
    }
  }

  async unassignSupportChat(input: JamSdk.UnassignSupportChatCommandInput) {
    try {
      return await this.client.unassignSupportChat(input);
    } catch (error) {
      return error as Error;
    }
  }

  async unlockEventChallenges(input: JamSdk.UnlockEventChallengesCommandInput) {
    try {
      return await this.client.unlockEventChallenges(input);
    } catch (error) {
      return error as Error;
    }
  }

  async unlockTeamChallengeClue(input: JamSdk.UnlockTeamChallengeClueCommandInput) {
    try {
      return await this.client.unlockTeamChallengeClue(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateArenaDefinition(input: JamSdk.UpdateArenaDefinitionCommandInput) {
    try {
      return await this.client.updateArenaDefinition(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateCampaign(input: JamSdk.UpdateCampaignCommandInput) {
    try {
      return await this.client.updateCampaign(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateCampaignChangeRequest(input: JamSdk.UpdateCampaignChangeRequestCommandInput) {
    try {
      return await this.client.updateCampaignChangeRequest(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateCampaignComment(input: JamSdk.UpdateCampaignCommentCommandInput) {
    try {
      return await this.client.updateCampaignComment(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateCampaignGroup(input: JamSdk.UpdateCampaignGroupCommandInput) {
    try {
      return await this.client.updateCampaignGroup(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateCampaignRequest(input: JamSdk.UpdateCampaignRequestCommandInput) {
    try {
      return await this.client.updateCampaignRequest(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateCampaignTags(input: JamSdk.UpdateCampaignTagsCommandInput) {
    try {
      return await this.client.updateCampaignTags(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateChallenge(input: JamSdk.UpdateChallengeCommandInput) {
    try {
      return await this.client.updateChallenge(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateChallengeBoard(input: JamSdk.UpdateChallengeBoardCommandInput) {
    try {
      return await this.client.updateChallengeBoard(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateChallengeCfn(input: JamSdk.UpdateChallengeCfnCommandInput) {
    try {
      return await this.client.updateChallengeCfn(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateChallengeComment(input: JamSdk.UpdateChallengeCommentCommandInput) {
    try {
      return await this.client.updateChallengeComment(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateChallengeIam(input: JamSdk.UpdateChallengeIamCommandInput) {
    try {
      return await this.client.updateChallengeIam(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateChallengeIssueAssignee(input: JamSdk.UpdateChallengeIssueAssigneeCommandInput) {
    try {
      return await this.client.updateChallengeIssueAssignee(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateChallengeIssueDescription(input: JamSdk.UpdateChallengeIssueDescriptionCommandInput) {
    try {
      return await this.client.updateChallengeIssueDescription(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateChallengeIssueDetails(input: JamSdk.UpdateChallengeIssueDetailsCommandInput) {
    try {
      return await this.client.updateChallengeIssueDetails(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateChallengeIssueStatus(input: JamSdk.UpdateChallengeIssueStatusCommandInput) {
    try {
      return await this.client.updateChallengeIssueStatus(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateChallengeLearningOutcome(input: JamSdk.UpdateChallengeLearningOutcomeCommandInput) {
    try {
      return await this.client.updateChallengeLearningOutcome(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateChallengeMaintainers(input?: JamSdk.UpdateChallengeMaintainersCommandInput) {
    try {
      return await this.client.updateChallengeMaintainers(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async updateChallengeNextSteps(input: JamSdk.UpdateChallengeNextStepsCommandInput) {
    try {
      return await this.client.updateChallengeNextSteps(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateChallengeSet(input: JamSdk.UpdateChallengeSetCommandInput) {
    try {
      return await this.client.updateChallengeSet(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateChallengeSettings(input: JamSdk.UpdateChallengeSettingsCommandInput) {
    try {
      return await this.client.updateChallengeSettings(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateChallengeSummary(input: JamSdk.UpdateChallengeSummaryCommandInput) {
    try {
      return await this.client.updateChallengeSummary(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateChallengeTags(input: JamSdk.UpdateChallengeTagsCommandInput) {
    try {
      return await this.client.updateChallengeTags(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateChallengeTask(input: JamSdk.UpdateChallengeTaskCommandInput) {
    try {
      return await this.client.updateChallengeTask(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateChallengeTaskConfig(input: JamSdk.UpdateChallengeTaskConfigCommandInput) {
    try {
      return await this.client.updateChallengeTaskConfig(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateChallengeTesters(input: JamSdk.UpdateChallengeTestersCommandInput) {
    try {
      return await this.client.updateChallengeTesters(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateChallengeTranslation(input: JamSdk.UpdateChallengeTranslationCommandInput) {
    try {
      return await this.client.updateChallengeTranslation(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateChallengeWiki(input: JamSdk.UpdateChallengeWikiCommandInput) {
    try {
      return await this.client.updateChallengeWiki(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateEvent(input: JamSdk.UpdateEventCommandInput) {
    try {
      return await this.client.updateEvent(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateEventChallengeProperties(input: JamSdk.UpdateEventChallengePropertiesCommandInput) {
    try {
      return await this.client.updateEventChallengeProperties(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateEventChangeRequest(input: JamSdk.UpdateEventChangeRequestCommandInput) {
    try {
      return await this.client.updateEventChangeRequest(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateEventComment(input: JamSdk.UpdateEventCommentCommandInput) {
    try {
      return await this.client.updateEventComment(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateEventRequest(input: JamSdk.UpdateEventRequestCommandInput) {
    try {
      return await this.client.updateEventRequest(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateEventTags(input: JamSdk.UpdateEventTagsCommandInput) {
    try {
      return await this.client.updateEventTags(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateLocalization(input: JamSdk.UpdateLocalizationCommandInput) {
    try {
      return await this.client.updateLocalization(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateLse(input?: JamSdk.UpdateLseCommandInput) {
    try {
      return await this.client.updateLse(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async updateParticipantProfile(input?: JamSdk.UpdateParticipantProfileCommandInput) {
    try {
      return await this.client.updateParticipantProfile(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async updateParticipantSkill(input?: JamSdk.UpdateParticipantSkillCommandInput) {
    try {
      return await this.client.updateParticipantSkill(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async updateUsagePlan(input?: JamSdk.UpdateUsagePlanCommandInput) {
    try {
      return await this.client.updateUsagePlan(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async updateUsagePlanAllowlist(input: JamSdk.UpdateUsagePlanAllowlistCommandInput) {
    try {
      return await this.client.updateUsagePlanAllowlist(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateUsagePlanComment(input: JamSdk.UpdateUsagePlanCommentCommandInput) {
    try {
      return await this.client.updateUsagePlanComment(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateUser(input: JamSdk.UpdateUserCommandInput) {
    try {
      return await this.client.updateUser(input);
    } catch (error) {
      return error as Error;
    }
  }

  async updateUserV2(input: JamSdk.UpdateUserV2CommandInput) {
    try {
      return await this.client.updateUserV2(input);
    } catch (error) {
      return error as Error;
    }
  }

  async uploadParticipants(input: JamSdk.UploadParticipantsCommandInput) {
    try {
      return await this.client.uploadParticipants(input);
    } catch (error) {
      return error as Error;
    }
  }

  async validateChallengeIamPolicy(input?: JamSdk.ValidateChallengeIamPolicyCommandInput) {
    try {
      return await this.client.validateChallengeIamPolicy(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async validateChallengeTemplate(input?: JamSdk.ValidateChallengeTemplateCommandInput) {
    try {
      return await this.client.validateChallengeTemplate(input || {});
    } catch (error) {
      return error as Error;
    }
  }

  async validateTeamChallengeTask(input: JamSdk.ValidateTeamChallengeTaskCommandInput) {
    try {
      return await this.client.validateTeamChallengeTask(input);
    } catch (error) {
      return error as Error;
    }
  }
}
